// extracted by mini-css-extract-plugin
export default {"outerContainer":"LayoutByTp_outerContainer__5k23d","body":"LayoutByTp_body__HJ9+X","leftSection":"LayoutByTp_leftSection__uAoZD","mainSection":"LayoutByTp_mainSection__hiNos"};